import React, { useEffect, useState, useContext } from "react";
import { CoreContainer, Notification, Icon } from "../common/style";
import { getProjectsForUser, createUserProject } from "../project/service";
import { CardBody } from "reactstrap";
import { Card, CardGroup } from "../product/style";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  Spinner,
  Card as ReactStrapCard,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
} from "reactstrap";
import NewProjectModal from "../project/NewProjectModal";
import {
  fetchOrganizationData,
  setFullStoryIdentity,
  isInternalAccess,
} from "../common/service";
import { isBrowser, isMobile, isMobileOnly } from "react-device-detect";
import { AppContext } from "../context";
import { getCurrentUser } from "../auth/service";
import { Header } from "../common";
import { cloneProject } from "./service";
import ConfirmationModal from "./ConfirmationModal";
import SampleOrdersModal from "./SampleOrdersModal";
import MobileBanner from "../common/MobileBanner";
// Sample Orders
const sampleOrders = [
  {
    id: 2291,
    name: "7 feet Wardrobe",
    image:
      "https://boxs-app.s3.ap-south-1.amazonaws.com/sample-orders/7_feet_wardrobe.jpg",
  },
];

const ProjectGridItem = (props) => {
  const [cloneConfirmationOpen, setCloneConfirmationOpen] = useState(false);

  const toggleCloneConfirmationState = () => {
    setCloneConfirmationOpen((prevState) => !prevState);
  };
  const clonedProject = () => {
    props.setIsLoading(true);
    return cloneProject({
      projectId: props.id,
      project: { type: "project", id: props.id },
    })
      .then((response) => {
        props.getProjects();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        props.setIsLoading(false);
      });
  };

  const handleCloneClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    toggleCloneConfirmationState();
  };

  return (
    <>
      <div className="col-12 col-sm-6 col-lg-4 col-xl-3 mt-3">
        <Link className="text-decoration-none" to={`/projects/${props.id}`}>
          <Card height="200px">
            <CardBody className="d-flex flex-column justify-content-center">
              <div className="fw-bold text-center mb-2" title={props.name}>
                {props.name}
              </div>
            </CardBody>
            <div className="d-flex justify-content-between align-content-center">
              {props.canAccessPrice && props.price !== null && (
                <>
                  <p className="m-0 text-secondary">₹{props.price}</p>
                  {props.meta &&
                    props.meta.price_correction_percentage &&
                    isInternalAccess() && (
                      <>
                        {props.meta.price_correction_percentage == -12 && (
                          <span className="ms-2 text-secondary text-nowrap">
                            pc: a
                          </span>
                        )}
                        {props.meta.price_correction_percentage == -8 && (
                          <span className="ms-2 text-secondary text-nowrap">
                            pc: b
                          </span>
                        )}
                      </>
                    )}
                </>
              )}
              <p className="m-0 text-secondary w-100 text-end">{props.owner}</p>
              <Icon
                className="fa-regular fa-clone ms-2 me-2"
                size="12px"
                onClick={handleCloneClick}
              />
            </div>
          </Card>
        </Link>
      </div>
      <ConfirmationModal
        isOpen={cloneConfirmationOpen}
        toggle={toggleCloneConfirmationState}
        onConfirm={() => {
          clonedProject();
          setCloneConfirmationOpen(false);
        }}
        message={`Are you sure you want to duplicate?`}
        headingText="Confirmation"
      />
    </>
  );
};

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(null);
  const navigate = useNavigate();
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [addProjectModal, setAddProjectModal] = useState(false);
  const [sampleModalOpen, setSampleModalOpen] = useState(false);
  const [loadingProjectId, setLoadingProjectId] = useState(null);
  const stateValue = useLocation().state;
  const { setOrganizationData } = useContext(AppContext);
  const [searchParams] = useSearchParams();
  const [isCanvasSupported, setIsCanvasSupported] = useState(false);
  const [search, setSearch] = useState("");

  const toggleAddProjectModal = () => setAddProjectModal(!addProjectModal);
  const toggleSampleModal = () => setSampleModalOpen(!sampleModalOpen);

  useEffect(() => {
    if (stateValue && stateValue.setIdentity) {
      setFullStoryIdentity();
    }
  }, []);

  const getProjects = () => {
    setIsLoading(true);

    getProjectsForUser({
      org_id: searchParams.get("org_id") || "",
      status: searchParams.get("status") || "",
    })
      .then((response) => {
        setIsCanvasSupported(response.is_canvas_supported);
        setProjects(response.projects);
      })
      .catch((err) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: err.error });
      })
      .finally((_) => setIsLoading(false));
  };

  useEffect(() => {
    getProjects();
  }, []);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const createProject = ({ payload: { name, version } }) => {
    setIsLoading(true);

    return createUserProject({
      name,
      version: version,
    })
      .then((response) => {
        setIsNotificationVisible(true);
        setNotification({
          type: "success",
          message: response.message,
        });

        const currentUser = getCurrentUser();

        if (currentUser) {
          fetchOrganizationData(currentUser.org_id).then((orgData) => {
            setOrganizationData(orgData);
          });
        }
        navigate(`${response.project_id}${isMobile ? "/cutlist" : ""}`);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const handleTryNowClick = (sampleProjectId, sampleProjectName) => {
    setLoadingProjectId(sampleProjectId);
    cloneProject({
      projectId: sampleProjectId,
      project: {
        type: "project",
        id: sampleProjectId,
        name: sampleProjectName,
      },
    })
      .then((response) => {
        navigate(`/projects/${response.clone_items.id}`);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => {
        setLoadingProjectId(null);
        setSampleModalOpen(false);
      });
  };

  return isLoading || isLoading === null ? (
    <CoreContainer>
      <Spinner>Loading...</Spinner>
    </CoreContainer>
  ) : (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <Header nav={true} toggleSampleModal={toggleSampleModal} />
      {isMobileOnly && <MobileBanner />}
      <div className="bg-light border-bottom">
        <div className="container-fluid px-4">
          <div className="row align-items-center" style={{ minHeight: 80 }}>
            <div className="col-md-6 col-12 py-3">
              <input
                type="search"
                className="form-control fs-6 p-2"
                style={{ width: 500, }}
                placeholder="Search..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="col-md-6 col-12 text-md-end text-start py-3">
              <Button color="primary" onClick={toggleAddProjectModal} size="lg">
                Add Project
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid px-4 pt-4">
        {projects && projects.length > 0 ? (
          <CardGroup className="row" browser={isBrowser.toString()}>
            {projects
              .filter(project =>
                project.name
                  ?.toLowerCase()
                  .includes(search.toLowerCase())
              )
              .map((project, index) => (
                <ProjectGridItem
                  key={index}
                  id={project.id}
                  name={project.name}
                  value={project.value}
                  owner={project.owner.name}
                  canAccessPrice={project.owner.can_access_price}
                  price={project.price}
                  getProjects={getProjects}
                  setIsLoading={setIsLoading}
                  setIsNotificationVisible={setIsNotificationVisible}
                  setNotification={setNotification}
                  meta={project.meta}
                />
              ))}
          </CardGroup>
        ) : (
          <div className="text-center rounded cursor-pointer border shadow py-5 text-center mt-2">
            <div className="fs-2 fw-bold mb-4">Welcome to Boxs!</div>
            <div className="d-flex justify-content-center mt-3 gap-2">
              <button
                type="button"
                className="btn btn-primary fs-6 p-3"
                onClick={toggleSampleModal}
              >
                Explore Sample Orders
              </button>
              <button
                type="button"
                className="btn btn-outline-primary fs-6 p-3"
                onClick={toggleAddProjectModal}
              >
                Create first project
              </button>
            </div>
          </div>
        )}
      </div>

      <NewProjectModal
        isOpen={addProjectModal}
        toggle={toggleAddProjectModal}
        onSuccess={(payload) => createProject({ payload })}
        isCanvasSupported={isCanvasSupported}
      />

      <SampleOrdersModal
        isOpen={sampleModalOpen}
        toggle={toggleSampleModal}
        sampleOrders={sampleOrders}
        loadingProjectId={loadingProjectId}
        handleTryNowClick={handleTryNowClick}
      />
    </>
  );
};

export default Projects;
